// FLAG:useDocuAi — „In Prüfung zurücksetzen" is offered on three surfaces (Documents drawer
// „Weitere Funktionen", expense context menu, and the button inside the open review). They differ
// only in WHICH id they hold — file id (FileService.resetInvoiceReview) or expense id
// (ExpenseService.resetInvoiceReview) — but they must all react to a refusal the same way, so the
// refusal handling lives here instead of being re-invented three times with three different toasts.
//
// Deliberately free of service imports: pulling ExpenseService in here would drag the whole redux
// store into every consumer (and into jest).
import lang from '@/lang'
import { errorCodes } from '@/modules/base/util/constants'
import { toast } from '@/modules/base/components/toast/toastConfig'

interface ApiErrorLike {
  body?: {
    meta?: Record<string, { code?: string }[]>
  }
}

/**
 * The API answers a refusal as `{ meta: { <field>: [{ code }] } }` (ValidationError). Returns the
 * first code it carries, so a caller can distinguish "already booked" from a generic failure.
 */
export const getResetInvoiceReviewErrorCode = (error: ApiErrorLike | null | undefined): string | null => {
  const meta = error?.body?.meta
  if (!meta) return null

  return Object.values(meta)
    .flat()
    .map(entry => entry?.code)
    .find(code => !!code) ?? null
}

/** Named refusal → its own message; anything else → the generic one. Never silent. */
export const showResetInvoiceReviewError = (error: ApiErrorLike | null | undefined): void => {
  const code = getResetInvoiceReviewErrorCode(error)
  const messages = lang.documents.resetInvoiceReview

  if (code === errorCodes.EXPENSE_BOOKED) {
    toast.showToast({ type: 'error', message: messages.errorExpenseBooked })
    return
  }
  if (code === errorCodes.NO_ANALYSIS_RESULT) {
    toast.showToast({ type: 'error', message: messages.errorNoAnalysis })
    return
  }
  toast.showToast({ type: 'error', message: messages.error })
}
